import { render } from "./DmvtTkGroupped.vue?vue&type=template&id=8afb277e&ts=true"
import script from "./DmvtTkGroupped.vue?vue&type=script&lang=ts"
export * from "./DmvtTkGroupped.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__